/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleLightDto
 */
export interface RoleLightDto {
    /**
     * Role ID
     * @type {string}
     * @memberof RoleLightDto
     */
    id: string;
    /**
     * Role name
     * @type {string}
     * @memberof RoleLightDto
     */
    name: string;
    /**
     * Role description
     * @type {string}
     * @memberof RoleLightDto
     */
    description: string;
    /**
     * Role rights
     * @type {Array<string>}
     * @memberof RoleLightDto
     */
    rightIds: Array<string>;
    /**
     * Role providers
     * @type {Array<string>}
     * @memberof RoleLightDto
     */
    providerIds: Array<string>;
    /**
     * Role created on
     * @type {Date}
     * @memberof RoleLightDto
     */
    createdOn: Date;
    /**
     * Role updated on
     * @type {Date}
     * @memberof RoleLightDto
     */
    updatedOn: Date;
}

/**
 * Check if a given object implements the RoleLightDto interface.
 */
export function instanceOfRoleLightDto(value: object): value is RoleLightDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('rightIds' in value) || value['rightIds'] === undefined) return false;
    if (!('providerIds' in value) || value['providerIds'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    if (!('updatedOn' in value) || value['updatedOn'] === undefined) return false;
    return true;
}

export function RoleLightDtoFromJSON(json: any): RoleLightDto {
    return RoleLightDtoFromJSONTyped(json, false);
}

export function RoleLightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleLightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'rightIds': json['rightIds'],
        'providerIds': json['providerIds'],
        'createdOn': (new Date(json['createdOn'])),
        'updatedOn': (new Date(json['updatedOn'])),
    };
}

export function RoleLightDtoToJSON(json: any): RoleLightDto {
    return RoleLightDtoToJSONTyped(json, false);
}

export function RoleLightDtoToJSONTyped(value?: RoleLightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'rightIds': value['rightIds'],
        'providerIds': value['providerIds'],
        'createdOn': ((value['createdOn']).toISOString()),
        'updatedOn': ((value['updatedOn']).toISOString()),
    };
}

